import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { useEffect } from 'react';
import * as React from 'react';

const ClearErrors = ({ actionCreators, clearErrors }): React.ReactElement => {
	useEffect(() => {
		if (Array.isArray(actionCreators)) {
			actionCreators.forEach((actionCreator) => clearErrors(actionCreator));
		} else {
			clearErrors(actionCreators);
		}
	}, []);

	return null;
};

const mapDispatchToProps = (dispatch, ownProps) => ({
	clearErrors: (actionCreators) => dispatch(actionCreators.clearErrors()),
});

export default withRouter<any, any>(connect(null, mapDispatchToProps)(ClearErrors));
